
.Workflow {
    padding: 1rem;
    display: grid;
    grid-template: max-content auto / auto;
    gap: .5rem;

    @media (min-width: 40rem) {
        grid-template: max-content / 2fr 1fr;
    }
    @media (min-width: 70rem) {
        grid-template: max-content / 3fr 1fr;
    }
}

.Workflow__main {
    display: block;
    /* Let the column shrink narrower than its content wants, so a wide
       card or form cannot push the page wider than the screen. */
    min-width: 0;
}

.Workflow__aside {
    display: block;
    min-width: 0;
}
